import { useMutation } from 'react-query'

import { APIError } from '../../../../../utils'
import { voidVatDeclarationPayment } from '../../../query-api'

interface UseVoidVatDeclarationPaymentProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export interface VoidVatDeclarationPaymentProps {
  vatDeclarationId: string
}

export const useVoidVatDeclarationPayment = (props?: UseVoidVatDeclarationPaymentProps) => {
  const { onError, onSuccess } = props || {}

  const { mutate: voidPeriodPayment, isLoading: isProcessing } = useMutation(
    ({ vatDeclarationId }: VoidVatDeclarationPaymentProps) => voidVatDeclarationPayment(vatDeclarationId),
    {
      onError,
      onSuccess,
    },
  )

  return { isProcessing, voidPeriodPayment }
}
